import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import Money from '../../../common/money';
import Date from '../../../common/date';
import { t } from '../../../../modules/infra/i18n';

const DashboardDeposits = ({ deposits }) => (
  <ReactTable
    data={[{
      title: t('reports:dashboard.last_deposit'),
      ...deposits.last,
    }, {
      title: t('reports:dashboard.next_deposit'),
      ...deposits.next,
    }]}
    showPagination={false}
    minRows={0}
    className="c-table-new c-table--small c-no-hover u-mt--"
    columns={[{
      Header: '',
      accessor: 'title',
      id: 'title',
      className: 'u-text-center',
    }, {
      Header: t('reports:dashboard.amount'),
      accessor: 'amount',
      id: 'amount',
      className: 'u-text-center',
      Cell: props => <Money cents={props.value} />,
    }, {
      Header: t('reports:dashboard.date'),
      accessor: 'date',
      id: 'date',
      className: 'u-text-center',
      Cell: props => <Date date={props.value * 1000} />
    }]}
  />
);

DashboardDeposits.propTypes = {
  deposits: PropTypes.object,
};
DashboardDeposits.defaultProps = {
  deposits: {},
};

export default DashboardDeposits;
